import { Button, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Add, PrintOutlined, PrintSharp } from "@material-ui/icons";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import FilterListIcon from "@material-ui/icons/FilterList";
import SyncIcon from "@material-ui/icons/Sync";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { LOCKED_STATUS, PAGESIZE_ALL } from "app/common/LocalConst";
import {
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleTechician,
  isSalesConsultant,
  transformDate,
} from "app/common/LocalFunction";
import {
  lockTreatment,
  pagingTreatmentPlanCard,
} from "app/services/TreatmentPlanCardService";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import LockRetainedPopup from "../FeeTab/Popup/LockRetainedPopup";
import PaymentVoucherPopup from "../FeeTab/Popup/PaymentVoucherPopup";
import ListRegisterCard from "./ListRegisterCard";
import ChangeCardPopup from "./Popup/ChangeCardPopup";
import HistoryCardPopup from "./Popup/HistoryCardPopup";
import HistoryUsedCardPopup from "./Popup/HistoryUsedCardPopup";
import RegisterCardAdvicePopup from "./Popup/RegisterCardAdvicePopup";
import RegisterCardPopup from "./Popup/RegisterCardPopup";
import RegisterCradPreviewPrintPopup from "./Popup/RegisterCardPreviewPrintPopup";
import SearchRegisterCard from "./SearchRegisterCard";

const RegisterCardIndex = ({ tabValue }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    searchRegisterCard,
    handleChangeFormSearchService,
    openCreateOrEditCardPopup,
    handleOpenCreateOrEditCardPopup,
    handleCloseCreateOrEditCardPopup,
    saveOrUpdateRegisterCard,
    openConfirmDelete,
    handleOpenConfirmDelete,
    handleDeleteCard,
    openConfirmMessageNotRemove,
    handleCloseConfirmMessageNotRemove,
    openAddCardAdvicePopup,
    openUpdateCardAdvicePopup,
    dataRegisterCard,
    initRegisterCard,
    handleCloseAddCardAdvicePopup,
    handleCloseUpdateCardAdvicePopup,
    saveOrUpdateCardAdvice,
    pagingRegisterCard,
    handleOpenAddCardAdvicePopup,
    pageRegisterCard,
    printContent,
    handleSetPrintContent,
    searchHistoryUsedCard,
    handleCloseHistoryUsedPopup,
    openHistoryUsedCard,
    handleChangeFormSearchHistoryUsedCard,
    pageHistoryUsedCard,
    handleChangeFormSearchCardAdvice,
    searchListCardAdvice,
    openChangeCardPopup,
    initChangeCard,
    handleCloseChangeCardPopup,
    handleChangeCard,
    openConfirmUnlock,
    handleCloseConfirmUnlock,
    handleConfirmUnlock,
    openConfirmLock,
    handleCloseConfirmLock,
    handleConfirmLock,
    openHistoryCardPopup,
    handleCloseHistoryCardPopup,
    searchDataHistory,
    pageDataHistory,
    handleChangeFormSearchHistory,
    openConfirmError,
    handleCloseConfirm,
  } = useStore().patientManagementStore.registerCardStore;

  const { treatmentFree } =
    useStore().patientManagementStore.registerTreatmentPlanStore;

  const {
    initialPatient,
    listVatPercent,
    customerSourceWalkIn,
    handleGetPatientOverviewByIdNotLoading,
  } = useStore().patientManagementStore.patientGeneralStore;

  const {
    openTotalBillStatusInvoiceItemConfirm,
    handleCloseTotalBillStatusInvoiceItemConfirm,
    updateTotalBillStatusInvoiceItem,
    listStk,
    listPos,
    listHomecredit,
    listPos_tragop,
    openPaymentVoucherPopup,
    initialPaymentVoucher,
    createPaymentVoucherWithListMethod,
    listPaymentMethod,
    getListPaymentMethod,
    handleClosePaymentVoucherPopup,
    getListProperties,
    openFormLockRetained,
    handleCloseFormLockRetaind,
    initialLockRetained,
    handleLockRetaind,
    defaultFreePromotion,
  } = useStore().feeStore.serviceFeeTabStore;

  let [isOpenFillter, setOpenFillter] = useState(true);
  const defaultDepartment = useDefaultDepartment();

  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchService({
        ...searchRegisterCard,
        patientId,
        fromDate: null,
        toDate: null,
      });
      getListPaymentMethod();
      getListProperties({
        departmentIds: defaultDepartment ? [defaultDepartment.id] : [],
      });
    }
  }, [patientId]);

  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });

  async function handlePrintAllItems() {
    try {
      const payload = {
        ...searchRegisterCard,
        pageIndex: 1,
        pageSize: PAGESIZE_ALL,
        patientId,
      };

      if (!patientId) {
        throw new Error("Chưa xác định được bệnh nhân");
      }

      const { data } = await pagingTreatmentPlanCard(payload);

      handleSetPrintContent(data?.content || []);
    } catch (error) {
      toast.error("Có lỗi xảy ra khi in tất cả dữ liệu, vui lòng thử lại sau");
      console.error(error);
    }
  }

  async function handlePrintChosenItems(chosenCards) {
    try {
      const chosenItems = [...chosenCards];

      handleSetPrintContent(chosenItems || []);
    } catch (error) {
      toast.error("Có lỗi xảy ra khi in tất cả dữ liệu, vui lòng thử lại sau");
      console.error(error);
    }
  }

  let isAdminPermission = isAdmin();
  let isRoleCashierPermission = isRoleCashier();
  let isRoleBranchManagerPermission = isRoleBranchManager();
  let isSalesConsultantPermission = isSalesConsultant();
  const isReadonly = isRoleHisReadOnly();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isDoctors = isDoctor();
  const isAccountant = isRoleHisAccountant();

  const hasAddPermission =
    isAdmins ||
    isRoleCashierPermission ||
    isAccountant ||
    isRoleBranchManagerPermission;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <section className="form-patient " style={{ margin: "4px" }}>
      <div style={{ backgroundColor: "#bdfff342" }}>
        <Formik
          initialValues={searchRegisterCard}
          validationSchema={searchPatientValidationSchema}
          onSubmit={(values) => {
            handleChangeFormSearchService(values);
          }}
          enableReinitialize
        >
          {({ values }) => {
            return (
              <Form autoComplete="off">
                <>
                  <div
                    className=" flex justify-between gap-2"
                    style={{ fontSize: "16px" }}
                  >
                    <p className="cards-header flex">
                      <span
                        className="flex items-center pointer"
                        style={{ fontWeight: "bold" }}
                      >
                        Thẻ
                      </span>
                      <span
                        style={{ cursor: "pointer" }}
                        className="flex items-center"
                        onClick={() => setOpenFillter(!isOpenFillter)}
                      >
                        <FilterListIcon color="red" />
                      </span>
                    </p>

                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      {!isMobile && values?.chosenCards?.length > 0 && (
                        <Tooltip
                          placement="top"
                          arrow
                          title="Tạo phiếu in các hạng mục đã chọn"
                        >
                          <Button
                            onClick={async (e) => {
                              handlePrintChosenItems(values?.chosenCards);
                            }}
                            style={{
                              backgroundColor: "#f16321",
                              color: "white",
                              marginRight: "4px",
                            }}
                          >
                            <PrintOutlined />
                            In tùy chọn
                          </Button>
                        </Tooltip>
                      )}

                      {!isMobile ||
                        (!isReadonly &&
                          pageRegisterCard?.content?.length > 0 && (
                            <Tooltip title={"In tất cả thẻ"}>
                              <Button
                                onClick={async (e) => {
                                  handlePrintAllItems();
                                }}
                                style={{
                                  backgroundColor: "#f16321",
                                  color: "white",
                                  marginRight: "4px",
                                }}
                              >
                                <PrintSharp />
                                In phiếu
                              </Button>
                            </Tooltip>
                          ))}

                      {hasAddPermission && (
                        <CommonButton
                          className="btn-add"
                          onClick={async (e) =>
                            setAnchorEl(anchorEl ? null : e.target)
                          }
                          style={{ position: "relative", height: "100%" }}
                        >
                          <Add />
                          Thẻ trả trước
                        </CommonButton>
                      )}

                      {anchorEl && hasAddPermission && (
                        <div
                          className="popover-list"
                          style={{
                            right: 0,
                            left: "auto",
                            position: "absolute",
                            minWidth: "160px",
                          }}
                        >
                          <div
                            className="popover-item popover-item-custom"
                            style={{ color: "#4276a4" }}
                            onClick={() => {
                              handleOpenCreateOrEditCardPopup(
                                null,
                                initialPatient?.patientInfo,
                                defaultDepartment
                              );
                              setAnchorEl(null);
                            }}
                          >
                            <AddCircleOutlineIcon
                              fontSize="small"
                              className="icon"
                            />
                            Thêm
                          </div>
                          <div
                            className="popover-item"
                            style={{ color: "#4276a4" }}
                            onClick={() => {
                              handleOpenAddCardAdvicePopup({
                                orderDate: values?.orderDate,
                                patientId,
                              });
                              setAnchorEl(null);
                            }}
                          >
                            <SyncIcon
                              fontSize="small"
                              color="#007b8f"
                              className="icon"
                            />
                            Lấy từ tư vấn
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {!isOpenFillter && (
                    <>
                      <style>
                        {`
                    @keyframes slideDownFade {
                      0% {
                        opacity: 0;
                        transform: translateY(-10px);
                      }
                      100% {
                        opacity: 1;
                        transform: translateY(0);
                      }
                    }
                  `}
                      </style>
                      <div
                        style={{
                          animation: "slideDownFade 0.3s ease forwards",
                          zIndex: 10,
                          position: "relative",
                        }}
                      >
                        <SearchRegisterCard
                          handleOpenCreateOrEditPopup={
                            handleOpenCreateOrEditCardPopup
                          }
                        />
                      </div>
                    </>
                  )}

                  <ListRegisterCard />
                </>
              </Form>
            );
          }}
        </Formik>

        {/* popup thẻ */}

        {!!openCreateOrEditCardPopup && (
          <RegisterCardPopup
            open={!!openCreateOrEditCardPopup}
            handleClose={handleCloseCreateOrEditCardPopup}
            onSubmit={saveOrUpdateRegisterCard}
            initRegisterCard={{ ...initRegisterCard, patientId }}
            patient={initialPatient?.patientInfo}
            listVatPercent={listVatPercent}
            customerSourceWalkIn={customerSourceWalkIn}
            handleAfterSubmit={() =>
              handleGetPatientOverviewByIdNotLoading(patientId)
            }
            defaultFreePromotion={defaultFreePromotion}
          />
        )}

        {!!openAddCardAdvicePopup && (
          <RegisterCardAdvicePopup
            open={!!openAddCardAdvicePopup}
            handleClose={() => {
              handleCloseAddCardAdvicePopup();
              pagingRegisterCard();
            }}
            patient={initialPatient?.patientInfo}
            dataRegisterCard={dataRegisterCard}
            onSubmit={handleChangeFormSearchCardAdvice}
            initialData={searchListCardAdvice}
            customerSourceWalkIn={customerSourceWalkIn}
          />
        )}

        {!!openUpdateCardAdvicePopup && (
          <RegisterCardPopup
            open={!!openUpdateCardAdvicePopup}
            handleClose={handleCloseUpdateCardAdvicePopup}
            onSubmit={async (values) => {
              await saveOrUpdateCardAdvice(values);
            }}
            initRegisterCard={{
              ...initRegisterCard,
              patientId,
            }}
            listVatPercent={listVatPercent}
            customerSourceWalkIn={customerSourceWalkIn}
            patient={initialPatient?.patientInfo}
          />
        )}

        {openConfirmDelete && (
          <ConfirmPopup
            open={openConfirmDelete}
            onClose={() => handleOpenConfirmDelete(null)}
            text="Bạn có chắc chắn muốn hủy thẻ trả trước này không ?"
            onConfirm={async () => {
              await handleDeleteCard();
              if (patientId) {
                await handleGetPatientOverviewByIdNotLoading(patientId);
              }
            }}
          />
        )}

        {!!openConfirmMessageNotRemove && (
          <ConfirmPopup
            open={!!openConfirmMessageNotRemove}
            onClose={() => handleCloseConfirmMessageNotRemove(null)}
            text={openConfirmMessageNotRemove}
            hideConfirm
            textClose={"Quay lại"}
            title="Thao tác thất bại"
          />
        )}

        {printContent?.length > 0 && (
          <RegisterCradPreviewPrintPopup
            open={printContent?.length > 0 ? true : false}
            handleClose={() => handleSetPrintContent([])}
            patient={initialPatient}
          />
        )}

        {!!openHistoryUsedCard && (
          <HistoryUsedCardPopup
            open={openHistoryUsedCard}
            handleClose={handleCloseHistoryUsedPopup}
            searchHistoryUsedCard={searchHistoryUsedCard}
            pageHistoryUsedCard={pageHistoryUsedCard}
            handleChangeFormSearch={handleChangeFormSearchHistoryUsedCard}
          />
        )}

        {!!openChangeCardPopup && (
          <ChangeCardPopup
            open={!!openChangeCardPopup}
            handleClose={handleCloseChangeCardPopup}
            initChangeCard={{
              ...initChangeCard,
              patientId,
            }}
            patient={initialPatient?.patientInfo}
            listVatPercent={listVatPercent}
            customerSourceWalkIn={customerSourceWalkIn}
            onSubmit={handleChangeCard}
            handleAfterSubmit={() =>
              handleGetPatientOverviewByIdNotLoading(patientId)
            }
            treatmentFree={treatmentFree}
          />
        )}

        {openConfirmLock && (
          <ConfirmPopup
            open={openConfirmLock}
            onClose={handleCloseConfirmLock}
            text="Bạn có muốn khóa thẻ không ?"
            onConfirm={async () => {
              await handleConfirmLock();
              if (patientId) {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }
            }}
          />
        )}
        {openConfirmUnlock && (
          <ConfirmPopup
            open={openConfirmUnlock}
            onClose={handleCloseConfirmUnlock}
            text="Bạn có muốn mở khóa thẻ không ?"
            onConfirm={async () => {
              await handleConfirmUnlock();
              if (patientId) {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }
            }}
          />
        )}

        {openHistoryCardPopup && (
          <HistoryCardPopup
            open={openHistoryCardPopup}
            handleClose={handleCloseHistoryCardPopup}
            searchData={searchDataHistory}
            pageDataHistory={pageDataHistory}
            handleChangeFormSearch={handleChangeFormSearchHistory}
          />
        )}
        {openTotalBillStatusInvoiceItemConfirm && (
          <ConfirmPopup
            open={openTotalBillStatusInvoiceItemConfirm}
            onClose={handleCloseTotalBillStatusInvoiceItemConfirm}
            text="Bạn có muốn tính số tiền và cập nhật trạng thái thanh toán không ?"
            onConfirm={updateTotalBillStatusInvoiceItem}
          />
        )}
        {openPaymentVoucherPopup && (
          <PaymentVoucherPopup
            open={openPaymentVoucherPopup}
            handleClose={handleClosePaymentVoucherPopup}
            initialPaymentVoucher={initialPaymentVoucher}
            handleSubmit={async (values, setSubmitting) => {
              const data = await createPaymentVoucherWithListMethod(
                {
                  ...values,
                  notPaging: true,
                },
                setSubmitting
              );
              if (data?.responseStatus !== false) {
                const treatmentId = values?.treatmentPlanCard?.id;
                if (treatmentId) {
                  const treatmentInList = pageRegisterCard?.content?.find(
                    (item) => item?.id === treatmentId
                  );
                  if (treatmentInList?.cardStatus !== LOCKED_STATUS) {
                    await lockTreatment(treatmentId);
                  }
                }
                await handleGetPatientOverviewByIdNotLoading(patientId);
                await pagingRegisterCard();
              }
            }}
            patient={initialPatient?.patientInfo}
            listPaymentMethod={listPaymentMethod}
            listStk={listStk}
            listPos={listPos}
            listHomecredit={listHomecredit}
            listPos_tragop={listPos_tragop}
          />
        )}

        {openFormLockRetained && (
          <LockRetainedPopup
            handleClose={handleCloseFormLockRetaind}
            initialValues={initialLockRetained}
            onConfirm={handleLockRetaind}
            open={openFormLockRetained}
            handleAfterSubmit={() => {
              pagingRegisterCard();
              setTimeout(() => {
                handleGetPatientOverviewByIdNotLoading(patientId);
              }, 400);
            }}
          />
        )}

        {!!openConfirmError && (
          <ConfirmPopup
            open={!!openConfirmError}
            onClose={() => handleCloseConfirm(null)}
            text={openConfirmError}
            hideConfirm
            textClose={"Quay lại"}
            title="Thao tác thất bại"
          />
        )}
      </div>
    </section>
  );
};

export default memo(observer(RegisterCardIndex));
